import React from "react";

import l10n from "../services/localization";
import validators from "../services/validators";
import getVBMFields from "./vbm-fields";
import getOVRFields from "./ovr-fields";

export const findFieldInPage = (key, page) => {
  return page.elements.find((e) => {
    return e.key === key;
  });
};

export default function getFormFields(appJson, formData, munis = []) {
  let fields = [
    // page 0
    {
      title: l10n.getString("titles.contactInfo"),
      slug: "onboarding",
      elements: [
        {
          key: "full-name",
          handler: "input",
          label: "First and Last Name",
          validator: validators.fullName,
        },
        {
          key: "phone-number",
          handler: "input",
          inputMode: "numeric",
          label: l10n.getString("labels.mobilePhoneNumber"),
          validator: validators.phoneNumber,
          mask: "999-999-9999",
        },
        {
          key: "address",
          handler: "address",
          label: "Registration Address",
          validator: (place) => validators.validateAddress(place, "PA"),
          hint: "Apartment number can be added in a later step.",
        },
        {
          handler: "text",
          value: (
            <div>
              <div className="muted paid-for">
                <p>
                  Paid for by Tech for Campaigns,{" "}
                  <a href="https://techforcampaigns.org">techforcampaigns.org</a>. Not authorized by
                  any candidate or candidate&apos;s committee.
                </p>
                <p>
                  By clicking &ldquo;Next&rdquo; you consent to receive SMS messages from Tech for
                  Campaigns and those communicating on our behalf at the specific number you
                  provided. You certify, warrant, and represent that the phone number you provided
                  is your own and not someone else’s.
                </p>
              </div>
              <div className="muted">
                <p>
                  <a
                    href="https://www.techforcampaigns.org/privacy"
                    target="_blank"
                    rel="noopener noreferrer">
                    {l10n.getString("privacy")}
                  </a>
                </p>
              </div>
            </div>
          ),
        },
      ],
    },
    // page 1
    {
      title: "Select type of application",
      slug: "select-application-type",
      elements: [
        {
          handler: "text",
          value: "Please choose one of the following options.",
        },
        {
          handler: "OVROrVBM",
          key: "_vbm_flow",
        },
      ],
    },
  ];
  if (formData["_vbm_flow"] === "Yes") {
    fields = [...fields, ...getVBMFields(appJson, munis)];
  } else {
    fields = [...fields, ...getOVRFields(appJson, munis)];
  }
  return fields;
}
